import { Component } from '@angular/core';
import { LoadingProgressService } from '../service/loading-progress.service';

/* Route-change progress bar. What it shows comes from LoadingProgressService
   (lazy chunk download, then the new page's HTTP requests); colour comes from
   the theme (--ui-accent). It sits above everything, so it is not inside a
   .ui-card and carries its own token references. */
@Component({
  selector: 'app-progress',
  template: `<div
    class="ui-progress route-progress"
    [class.is-visible]="loading.visible$ | async"
    aria-hidden="true"
  >
    <span
      class="ui-progress__bar"
      [style.width.%]="loading.progress$ | async"
    ></span>
  </div>`,
  styles: [
    `
      .route-progress {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10000;
        width: 100%;
        height: 4px;
        border-radius: 0;
        background: transparent;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.25s ease;
      }
      .route-progress.is-visible {
        opacity: 1;
      }
      .route-progress .ui-progress__bar {
        border-radius: 0 var(--ui-r-badge) var(--ui-r-badge) 0;
        background: linear-gradient(
          90deg,
          var(--ui-accent-hi),
          var(--ui-accent)
        );
        box-shadow: 0 0 8px var(--ui-accent-tint);
        transition: width 0.2s ease-out;
      }
      /* hidden → no width transition, so the reset to 0 never plays backwards */
      .route-progress:not(.is-visible) .ui-progress__bar {
        transition: none;
      }
      @media (prefers-reduced-motion: reduce) {
        .route-progress,
        .route-progress .ui-progress__bar {
          transition: none;
        }
      }
    `,
  ],
})
export class ProgressComponent {
  constructor(public loading: LoadingProgressService) {}
}
